module.exports = __webpack_public_path__ + "img/_pigeon_logo.8030c423.svg";